<template>
  <div
    class="ecogas-video padding-paragrafo padding-paragrafo--less padding-paragrafo--less--no-bottom">
    <div class="default-container">
      <div
        class="ecogas-video__fake-overlay"
        @click="$_playPause">
        <div
          v-if="!playing"
          class="ecogas-video__fake-overlay--play"><span>PLAY</span></div>

        <div
          v-else
          class="ecogas-video__fake-overlay--pause">
            <span v-if="pleaseWait">LOAD</span>
            <span v-else>PAUSE</span>
          </div>
      </div>
      <video v-if="videoId"
       :key="videoId"
        v-video="playerOptions"
        class="ecogas-video__video video-js"
        ></video>
    </div>
  </div>
</template>

<script>
import videojs from 'video.js'

export default {
  data: () => ({
    player: undefined,
    playing: false,
    pleaseWait: true
  }),
  props: {
    videoId: {
      type: Number,
      required: true
    },
    playerOptions: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  /* computed: {
    playerOptions: {
      get () {
        return {
          id: this.videoId,
          loop: true,
          controls: false,
          preload: 'auto',
          sources: [
              {
                src: 'https://videos.quammbase.it/download/streaming-playlists/hls/videos/5602a004-a7ac-46d5-9914-c9c07f9cb8b4-720-fragmented.mp4#t=0.5',
                type: 'video/mp4'
              }
            ]
        }
      }
    }
  }, */
  directives: {
    video: {
      bind (el, binding, vnode) {
        vnode.context.$data.player = videojs(el, binding.value)
        // vnode.context.$data.player.play()
        // https://npm.io/package/@vimeo/player
        vnode.context.$data.player.on('play', function () {
          vnode.context.$data.pleaseWait = false
        })
      },
      /* update(el, binding, vnode) {
        console.log('updato', binding)
        if (binding.value !== binding.oldValue) {
          console.log('updato')
          vnode.context.$data.player = new Player(el, binding.value)
        // vnode.context.$data.player.play()
        // https://npm.io/package/@vimeo/player
        vnode.context.$data.player.on('play', function () {
          vnode.context.$data.pleaseWait = false
        })
        }
      }, */
      unbind (el, binding, vnode) {
        // TODO: update
        vnode.context.$data.player.pause()
        vnode.context.$data.playing = false
      }
    }
  },
  methods: {
    $_playPause () {
      // console.log('call play/pause')
      if (!this.playing) this.player.play()
      else this.player.pause()
      this.playing = !this.playing
    }
  }
}
</script>

<style lang="scss">
@import "../assets/mixins/breakpoints";

.ecogas-video{
  background-color: #EFEFEC;
  display: block;
}

.ecogas-video__fake-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;

  .ecogas-video__fake-overlay--pause {
    opacity: 0;
    transition: all .8s cubic-bezier(.23,1,.32,1);
  }

  &:hover {
    .ecogas-video__fake-overlay--pause {
      opacity: 1;
    }
  }
}

.ecogas-video__fake-overlay--play, .ecogas-video__fake-overlay--pause {
  background: rgba($color: #4A4A4A, $alpha: .5);
  width: 75px;
  height: 75px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  color: #FFF;
  font-weight: 500;
  font-size: 1.4rem;
  cursor: pointer;

  @media #{$xlarge_mq} {
    font-size: 1.6rem;
    width: 100px;
    height: 100px;
  }

}

.ecogas-video video {
  width: 100%;
}

.ecogas-video iframe{
  width: 100%;
  height: calc(315px * (100vw - 52px) / 560);
  max-width: 100%;

  @media #{$large_mq} {
    height: calc(315px * 900 / 560);
  }
  @media #{$xlarge_mq} {
    height: calc(315px * 1260 / 560);
  }
  @media #{$xxlarge_mq} {
    height: calc(315px * 1440 / 560);
  }

}

</style>
